var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{directives:[{name:"t",rawName:"v-t",value:(("" + _vm.key)),expression:"`${key}`"}],staticClass:"operation",attrs:{"small":""}})}
var staticRenderFns = []

export { render, staticRenderFns }